import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";
import {
  EntitlementsFeatureUsageDto,
  IGetUserEntitlementsResponse,
  TFeatureKey,
} from "../types/users.types";

export const entitlementsDataSelector = (
  state: RootState
): IGetUserEntitlementsResponse | null => state.entitlements.data;

export const entitlementFeaturesSelector = createSelector(
  entitlementsDataSelector,
  (data): TFeatureKey[] => data?.features ?? []
);

export const planNameSelector = (state: RootState): string | null =>
  state.entitlements.data?.planName ?? null;

export const planIdSelector = (state: RootState): number | null =>
  state.entitlements.data?.planId ?? null;

export const trialSelector = (
  state: RootState
): { active: boolean; endsAt: string | null } | null =>
  state.entitlements.data?.trial ?? null;

export const aiQuotaSelector = (
  state: RootState
): IGetUserEntitlementsResponse["aiQuota"] | null =>
  state.entitlements.data?.aiQuota ?? null;

export const featureUsageSelector = createSelector(
  entitlementsDataSelector,
  (data): EntitlementsFeatureUsageDto[] => data?.featureUsages ?? []
);

export const resourceQuotasSelector = (
  state: RootState
): IGetUserEntitlementsResponse["resourceQuotas"] | null =>
  state.entitlements.data?.resourceQuotas ?? null;

// featureUsages carries only per-feature (behavioral) quotas; resource seat caps
// live in resourceQuotas, so every entry here is behavioral.
export const behavioralFeatureUsageSelector = featureUsageSelector;

export const featureUsageByKeySelector =
  (key: TFeatureKey) =>
  (state: RootState): EntitlementsFeatureUsageDto | undefined =>
    featureUsageSelector(state).find((u) => u.feature === key);

